import React, {FC, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {Navbar as GlobalNavbar, NavbarItem} from "Components/Layout/Navbar";
import Header from "Components/Layout/Header";
import GlobalLoader from "Vendor/Components/GlobalLoader";
import Api from "Vendor/Api";
import SecurityRule from "Entity/SecurityRule";

const Navbar: FC = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()
    const [rule, setRule] = useState<SecurityRule|undefined>(undefined)
    const [show, setShow] = useState<boolean>(false)
    const [search, setSearch] = useState<string>('')
    const [handleAdd, setHandleAdd] = useState<(() => void)|undefined>(undefined)

    useEffect(() => {
        if (location && location.state && typeof location.state === 'object') {
            setRule(location.state as SecurityRule);
        }
        else {
            let id = params.id;
            Api.get('/admin/edition/security-rule/' + id)
                .then((response ) => {
                    setRule(response.data as SecurityRule)
                })
        }
    }, [location, params])

    const items: NavbarItem[] = [
        {
            i18nLabel: 'app.general',
            path: ''
        },
        {
            i18nLabel:'app.properties',
            path:'properties'
        }
    ]

    return (
        <>
            {!rule
                ? <GlobalLoader />
                : <>
                    <Header
                        title={rule.name}
                        prev={() => {
                            navigate('/admin/edition/security-rule')
                        }}
                        externalUrl={rule.url}
                        add={() => {
                            handleAdd !== undefined && handleAdd()
                            setShow(true)
                        }}
                        search={search}
                        setSearch={setSearch}
                    />
                    <GlobalNavbar locationBase={"/admin/edition/security-rule/" + (rule?.id ?? '')} state={rule} items={items} />
                    <Outlet context={[rule, setRule, show, setShow, search, setSearch, setHandleAdd]} />
                </>
            }
        </>
    )
}

export default Navbar
